// Generated by purs version 0.13.8
"use strict";
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Capability_Navigate = require("../Lunarbox.Capability.Navigate/index.js");
var Lunarbox_Component_HOC_Connect = require("../Lunarbox.Component.HOC.Connect/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Constants = require("../Lunarbox.Constants/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Record = require("../Record/index.js");
var Logout = (function () {
    function Logout() {

    };
    Logout.value = new Logout();
    return Logout;
})();
var NavigateTo = (function () {
    function NavigateTo(value0) {
        this.value0 = value0;
    };
    NavigateTo.create = function (value0) {
        return new NavigateTo(value0);
    };
    return NavigateTo;
})();
var Receive = (function () {
    function Receive(value0) {
        this.value0 = value0;
    };
    Receive.create = function (value0) {
        return new Receive(value0);
    };
    return Receive;
})();
var component = function (dictMonadEffect) {
    return function (dictMonadAff) {
        return function (dictMonadAsk) {
            return function (dictNavigate) {
                var render = function (state) {
                    var guest = Data_Maybe.isNothing(state.currentUser);
                    return Lunarbox_Component_Utils.container("home")([ Lunarbox_Component_Utils.container("bg")([  ]), Lunarbox_Component_Utils.container("header")([ Halogen_HTML_Elements.img([ Halogen_HTML_Properties.src(Lunarbox_Constants.transparentLogo), Halogen_HTML_Properties.id_("logo") ]), Lunarbox_Component_Utils.container("title-text")([ Lunarbox_Component_Utils.container("title")([ Halogen_HTML_Core.text("Lunarbox") ]), Lunarbox_Component_Utils.container("description")([ Halogen_HTML_Core.text("Functional programming made easy") ]) ]) ]), Lunarbox_Component_Utils.container("cta")([ Lunarbox_Component_Utils.container("cta-text")((function () {
                        if (guest) {
                            return [ Halogen_HTML_Core.text("Join lunarbox for "), Halogen_HTML_Elements.span([ Halogen_HTML_Properties.id_("free") ])([ Halogen_HTML_Core.text("free") ]), Halogen_HTML_Core.text("!") ];
                        };
                        return [ Halogen_HTML_Core.text("Start creating!") ];
                    })()), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id_("action-buttons"), Lunarbox_Component_Utils.className((function () {
                        if (guest) {
                            return "guest";
                        };
                        return "user";
                    })()) ])((function () {
                        if (guest) {
                            return [ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.id_("primary"), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(new NavigateTo(Lunarbox_Data_Route.Register.value)))) ])([ Halogen_HTML_Core.text("Signup") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.id_("secondary"), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(new NavigateTo(Lunarbox_Data_Route.Login.value)))) ])([ Halogen_HTML_Core.text("Login") ]) ];
                        };
                        return [ Halogen_HTML_Elements.button([ Halogen_HTML_Properties.id_("primary"), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(new NavigateTo(Lunarbox_Data_Route.Projects.value)))) ])([ Halogen_HTML_Core.text("Projects") ]), Halogen_HTML_Elements.button([ Halogen_HTML_Properties.id_("logout"), Halogen_HTML_Events.onClick(Data_Function["const"](new Data_Maybe.Just(Logout.value))) ])([ Halogen_HTML_Core.text("or logout") ]) ];
                    })()) ]) ]);
                };
                var handleAction = function (v) {
                    if (v instanceof NavigateTo) {
                        return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(v.value0);
                    };
                    if (v instanceof Receive) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Record.merge()()(v.value0));
                    };
                    if (v instanceof Logout) {
                        return Lunarbox_Capability_Navigate.logout(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate));
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.Home (line 56, column 18 - line 60, column 21): " + [ v.constructor.name ]);
                };
                return Lunarbox_Component_HOC_Connect.component(dictMonadAff)(dictMonadAsk)()(Halogen_Component.mkComponent({
                    initialState: Data_Function["const"]({
                        currentUser: Data_Maybe.Nothing.value
                    }),
                    render: render,
                    "eval": Halogen_Component.mkEval({
                        handleAction: handleAction,
                        handleQuery: Halogen_Component.defaultEval.handleQuery,
                        receive: function ($12) {
                            return Data_Maybe.Just.create(Receive.create($12));
                        },
                        initialize: Halogen_Component.defaultEval.initialize,
                        finalize: Halogen_Component.defaultEval.finalize
                    })
                }));
            };
        };
    };
};
module.exports = {
    component: component
};
